import { createSlice } from "@reduxjs/toolkit";

export const squads = createSlice({
  name: "squads",
  initialState: {
    id: "",
    squadList: [],
    isLoading: false,
  },
  reducers: {
    SetSquads(state, action) {
      state.squadList = action.payload;
    },
  },
  extraReducers: (builder) => {},
});

export const { SetSquads } = squads.actions;

export default squads.reducer;
